import axios from 'axios'
import api from "@/helpers/api";

const state = {
    items: {},
    titleTemplate: '%s | ZemSkidki.ru',
    delayPopupClose: 500,
    putAsideYes:168,
    putAsideNo:185,
}

// getters
const getters = {
    setRouble() {
        return detectOS() ? 'Р' : '₽';
    }
}

const actions = {
    getList(context, data) {
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_PATH+'/options/',api.axiosConfig()).then(response => {
                if(typeof response.data === 'object' && +response.data.error === 0) {
                    context.commit('setOption', response.data.result);
                    resolve();
                }
            }).catch(function (error) {
                reject();
            });
        });
    },
}

const mutations = {
    setOption(state, data) {
        if(typeof data === 'object') {
            state.items = data.items;
        }
    },
}



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

function detectOS() {
    let thisUserAgent = window.navigator.userAgent;
    let OS = thisUserAgent.indexOf("iPhone OS") != -1 || thisUserAgent.indexOf("Windows NT 6.1") != -1 || thisUserAgent.indexOf("iPad") != -1 || (thisUserAgent.indexOf('Macintosh') > -1 && 'ontouchend' in document);
    
    return OS;
}